import { render } from "./ScaricamentoContenuti.vue?vue&type=template&id=ba88698c&scoped=true"
import script from "./ScaricamentoContenuti.vue?vue&type=script&lang=js"
export * from "./ScaricamentoContenuti.vue?vue&type=script&lang=js"

import "./ScaricamentoContenuti.vue?vue&type=style&index=0&id=ba88698c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\utente\\Documents\\GitHub\\SCIENZE_NATURALI_app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba88698c"]])

export default __exports__